import { hasAmendmentDatePassed } from 'modules/Cube/domain/postActionStages/queries/hasAmendmentDatePassed'
import { AmendmentRefusal } from 'modules/Cube/view/layouts/quote/QuoteEditorHeader/executeQuote/utils/getAmendmentRefusal'

/**
 * What the next attempt to execute an amendment has to ask billing for, from
 * our own date and every refusal billing has given so far. Billing can refuse
 * for one reason and then the other, so each fix stays in once it's needed.
 *
 *   our date has passed, or billing said "past execute by" -> take effect today
 *   billing said "phase alignment"                         -> reset is required
 *
 * `today` is billing's, once it has told us, as its day can be ahead of ours.
 */
export const getExecuteConditions = ({
  effectiveFrom,
  ourToday,
  refusals
}: {
  effectiveFrom: Date | undefined
  ourToday: Date
  refusals: AmendmentRefusal[]
}): { today: Date; isLate: boolean; isResetRequiredByBilling: boolean } => {
  const billingToday = refusals.findLast(
    refusal => refusal.code === 'amendmentPastExecuteBy'
  )?.today
  const hasOurDatePassed = Boolean(
    effectiveFrom && hasAmendmentDatePassed({ effectiveFrom, today: ourToday })
  )

  return {
    today: billingToday ?? ourToday,
    isLate: hasOurDatePassed || Boolean(billingToday),
    isResetRequiredByBilling: refusals.some(
      refusal => refusal.code === 'amendmentPhaseAlignment'
    )
  }
}
